import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ImpersonationApi } from '../../api/impersonation.api';

@Injectable({ providedIn: 'root' })
export class ImpersonationService {
  private readonly _api = inject(ImpersonationApi);

  public getBuyerToken(buyerId: number): Observable<string> {
    return this._api.getBuyerToken(buyerId);
  }
}
